// src/config/index.js
// Central configuration for the application

export default {
    // API configuration
    api: {
        // Base URL for the Disc Golf Metrix API
        baseUrl: 'https://discgolfmetrix.com/api.php',

        // Default competition ID for Sunnmørstour
        // Change this value to switch to a different competition
        // SO: 3117525 r1: 3161908 - ST :3209725 - TG: 3221273 -- test: 3209723
        competitionId: '3209725'
    },

    // Refresh intervals (in milliseconds)
    refreshIntervals: {
        // Standard refresh interval (60 seconds)
        standard: 60000,

        // Leaderboard refresh interval (30 seconds)
        leaderboard: 60000
    }
}
